package de.ohhhmhhh.frontend.admin.ui.screens.user.subscriptions

import androidx.compose.runtime.*
import de.ohhhmhhh.backend.models.model.checkout.PaymentMethodEntity
import de.ohhhmhhh.frontend.admin.ui.components.buttons.Button
import de.ohhhmhhh.frontend.admin.ui.components.buttons.ButtonType
import de.ohhhmhhh.frontend.admin.ui.components.container.Dialog
import de.ohhhmhhh.frontend.admin.ui.components.container.Row
import de.ohhhmhhh.frontend.admin.ui.components.inputs.PriceInput
import de.ohhhmhhh.frontend.admin.ui.components.inputs.SelectInput
import de.ohhhmhhh.frontend.admin.ui.components.other.Spacer

@Composable
fun CreateCheckoutDialog(
    visible: MutableState<Boolean>,
    onInput: (Int, PaymentMethodEntity) -> Unit
) {
    var price by remember { mutableStateOf(0) }
    var paymentMethod by remember { mutableStateOf(PaymentMethodEntity.PAYPAL) }
    Dialog("Abonnement anlegen", visible, false) {
        Row({ classes("distribute") }) {
            SelectInput("Zahlungsmittel", listOf("PayPal", "Kreditkarte"), "PayPal") { v ->
                paymentMethod = when (v) {
                    "Kreditkarte" -> PaymentMethodEntity.STRIPE
                    else -> PaymentMethodEntity.PAYPAL
                }
            }
            PriceInput("Preis", price) { v ->
                price = v
            }
        }
        Spacer()
        Button("Versenden", ButtonType.HIGHLIGHT, attrs = { classes("ms-auto") }) {
            onInput(price, paymentMethod)
            visible.value = false
        }
    }
}